export const GG_WEB_CLIENT_ID = '437197947678-83jvicjh9i8vl1djdj0seug73d5jd6ti.apps.googleusercontent.com'
export const API_URL = 'https://van.akaky.xyz';